<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
<secure-app-header></secure-app-header>
<router-outlet></router-outlet>
